/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { DeleteAiCredentialMutationResponse, DeleteAiCredentialPathParams, DeleteAiCredential400, DeleteAiCredential401, DeleteAiCredential403, DeleteAiCredential404, DeleteAiCredential409, DeleteAiCredential500 } from "../../types/platformBillingController/DeleteAiCredential.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getDeleteAiCredentialUrl(organizationId: DeleteAiCredentialPathParams["organizationId"], provider: DeleteAiCredentialPathParams["provider"]) {
  const res = { method: 'DELETE', url: `/api/organizations/${organizationId}/platform-billing/credentials/${provider}` as const }
  return res
}

/**
 * @summary Delete a BYOK provider key
 * {@link /api/organizations/:organizationId/platform-billing/credentials/:provider}
 */
export async function deleteAiCredential(organizationId: DeleteAiCredentialPathParams["organizationId"], provider: DeleteAiCredentialPathParams["provider"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DeleteAiCredentialMutationResponse, ResponseErrorConfig<DeleteAiCredential400 | DeleteAiCredential401 | DeleteAiCredential403 | DeleteAiCredential404 | DeleteAiCredential409 | DeleteAiCredential500>, unknown>({ method : "DELETE", url : getDeleteAiCredentialUrl(organizationId, provider).url.toString(), ... requestConfig })
  return res.data
}